<div id="one_tap_container" [style.--one-tap-top-spacing]="topSpacing + 'px'"></div>
